import type {
  ContractDocuments,
  StaffGetContractSettlementResponse,
  StaffUpdateContractSettlementRequest,
  UploadedDocument,
} from '@urbanx/agx.campaigns.client';
import { dateOnlyToDate } from '@urbanx/agx.ui-components2';

export type SettlementFileValue = UploadedDocument | File;

export const getInitialSettlementDate = (
  actualSettlementDate?: StaffGetContractSettlementResponse['actualSettlementDate']
): Date => dateOnlyToDate(actualSettlementDate) ?? new Date();

const isFile = (value: SettlementFileValue | undefined): value is File =>
  typeof File !== 'undefined' && value instanceof File;

export const hasPersistedDocumentBeenRemoved = (
  selectedDocument: SettlementFileValue | undefined,
  originalDocument: UploadedDocument | undefined
): boolean => originalDocument != null && selectedDocument == null;

const persistedDocumentOrOriginal = (
  selectedDocument: SettlementFileValue | undefined,
  originalDocument: UploadedDocument | undefined
): UploadedDocument | null =>
  isFile(selectedDocument) ? (originalDocument ?? null) : (selectedDocument ?? null);

export const buildSettlementContractDocuments = ({
  vendorConfirmation,
  originalVendorConfirmation,
  buyerConfirmation,
  originalBuyerConfirmation,
  pexaConfirmation,
  originalPexaConfirmation,
}: {
  vendorConfirmation?: SettlementFileValue;
  originalVendorConfirmation?: UploadedDocument;
  buyerConfirmation?: SettlementFileValue;
  originalBuyerConfirmation?: UploadedDocument;
  pexaConfirmation?: SettlementFileValue;
  originalPexaConfirmation?: UploadedDocument;
}): StaffUpdateContractSettlementRequest['contractDocuments'] =>
  ({
    vendorSettlementConfirmation: persistedDocumentOrOriginal(
      vendorConfirmation,
      originalVendorConfirmation
    ),
    buyerSettlementConfirmation: persistedDocumentOrOriginal(
      buyerConfirmation,
      originalBuyerConfirmation
    ),
    pexaSettlementConfirmation: persistedDocumentOrOriginal(
      pexaConfirmation,
      originalPexaConfirmation
    ),
  }) as ContractDocuments;
